import store from 'store'
import { WS_GAME_CONFIGS } from '@/config/const'
import { getUrlParams } from '@/render/utils/helpers'

export default {
  data() {
    return {
      configs: {},
    }
  },
  created() {
    const storeConfigs = store.get(WS_GAME_CONFIGS) || {}
    const queryConfigs = getUrlParams()
    this.configs = { ...queryConfigs, ...storeConfigs }
  },
  mounted() {},
}
